<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                        >
                          <div>
                            <div class="text-xl font-bold mb-1">
                              Edit Account
                            </div>
                            <div class="mb-4">
                              You can modify your account info here. Kindly
                              ensure that information provided is up to date.
                            </div>
                            <hr />
                          </div>
                          <!--[form-content-start]-->
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                First Name *
                              </div>
                              <div id="ctrl-first_name-holder">
                                <InputText
                                  ref="ctrlfirst_name"
                                  v-model.trim="formData.first_name"
                                  label="First Name"
                                  type="text"
                                  placeholder="Enter First Name"
                                  class="w-full"
                                  :class="getErrorClass('first_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('first_name')"
                                  class="p-error"
                                  >{{ getFieldError("first_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Last Name *
                              </div>
                              <div id="ctrl-last_name-holder">
                                <InputText
                                  ref="ctrllast_name"
                                  v-model.trim="formData.last_name"
                                  label="Last Name"
                                  type="text"
                                  placeholder="Enter Last Name"
                                  class="w-full"
                                  :class="getErrorClass('last_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('last_name')"
                                  class="p-error"
                                  >{{ getFieldError("last_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Photo</div>
                              <div id="ctrl-photo-holder">
                                <div class="mb-1">
                                  <Uploader
                                    :class="getErrorClass('photo')"
                                    :auto="true"
                                    :fileLimit="1"
                                    :maxFileSize="3000000"
                                    accept=".jpg,.png,.gif,.jpeg"
                                    :multiple="false"
                                    style="width: 100%"
                                    label="Choose files or drop files here"
                                    upload-path="s3uploader/upload/photo"
                                    v-model="formData.photo"
                                  ></Uploader>
                                </div>
                                <small
                                  v-if="isFieldValid('photo')"
                                  class="p-error"
                                  >{{ getFieldError("photo") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Telephone *
                              </div>
                              <div id="ctrl-telephone-holder">
                                <InputText
                                  ref="ctrltelephone"
                                  v-model.trim="formData.telephone"
                                  label="Telephone"
                                  type="text"
                                  :disabled="true"
                                  placeholder="Enter Telephone"
                                  class="w-full"
                                  :class="getErrorClass('telephone')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('telephone')"
                                  class="p-error"
                                  >{{ getFieldError("telephone") }}</small
                                >
                              </div>
                            </div>
                          </div>
                          <hr />
                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update Profile Info"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "users",
  },
  routeName: {
    type: String,
    default: "usersaccountedit",
  },
  pagePath: {
    type: String,
    default: "account/edit",
  },
  apiPath: {
    type: String,
    default: "account/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default: "Record updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    first_name: "",
    last_name: "",
    telephone: "",
    photo: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  location.reload();
}
const rules = computed(() => {
  return {
    first_name: { required },
    last_name: { required },
    telephone: { required },
    photo: {},
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "My Account";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
